'use strict';

var _vue = require('./_vue');

var _vue2 = _interopRequireDefault(_vue);

var _tabmenu = require('./components/tabmenu.component');

var _tabmenu2 = _interopRequireDefault(_tabmenu);

var _stars = require('./components/stars.component');

var _stars2 = _interopRequireDefault(_stars);

var _timeSeries = require('./components/time-series.component');

var _timeSeries2 = _interopRequireDefault(_timeSeries);

var _breakdown = require('./components/breakdown.component');

var _breakdown2 = _interopRequireDefault(_breakdown);

var _fwwRepository = require('./library/fww-repository');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

new _vue2.default({

    el: document.querySelector('[data-vue="funds-finder-detail"]'),

    components: { tabmenu: _tabmenu2.default, stars: _stars2.default, timeSeries: _timeSeries2.default, breakdown: _breakdown2.default },

    data: function data() {
        return {
            detailChart: false
        };
    },
    mounted: function mounted() {
        (0, _fwwRepository.initializeFwwRepository)(JSON.parse(this.$el.getAttribute('data-vue-api')));
    },


    methods: {

        /**
         * Displays the given fund in the detailed chart.
         * @param event
         */
        showDetailChart: function showDetailChart() {
            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (event && event.preventDefault) {
                event.preventDefault();
            }

            // Set this.detailChart to show the overlay
            this.detailChart = true;

            // Add class to body element to hide scrollbars
            document.body.classList.add('c-ff-overlay-is-open');
        },


        /**
         * Hides the detail chart.
         */
        hideDetailChart: function hideDetailChart() {
            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (event && event.preventDefault) {
                event.preventDefault();
            }

            // Resets this.detailChart to hide the overlay
            this.detailChart = false;

            // Remove class from body to show scrollbars again.
            document.body.classList.remove('c-ff-overlay-is-open');
        }
    }
});